import { node, string } from "prop-types";
import React from "react";
import { classes } from "@insightfulscience/atomic-react/utils/classes";

const CardPriceBody = ({ children, className }) => (
	<div className={classes("card-price-content__body", className)}>{children}</div>
);

CardPriceBody.propTypes = {
	children: node.isRequired,
	className: string,
};

export default CardPriceBody;
